import { ButtonGroupField } from 'lib/iterable-hook-form/FormField';
import { ErrorText } from 'modules/campaigns/editor/styles';
import { ScheduleFormState } from 'modules/campaigns/editor/types';
import { useFormState } from 'react-hook-form';
import { GroupButton } from 'ui/buttonGroup';
import { FormField } from 'ui/formField';
import {
  SCHEDULE_CAMPAIGN_FORM_FIELDS,
  SEND_ON_DAYS_OPTIONS,
} from '../ScheduleCampaignModal.constants';

export const SkipOnDays = () => {
  const { errors } = useFormState<Pick<ScheduleFormState, 'skipOnDays'>>({
    name: ['skipOnDays'],
  });

  const { skipOnDays: skipOnDaysError } = errors;

  return (
    <FormField labelText="Skip sends on">
      <ButtonGroupField
        allowUnselect
        name={SCHEDULE_CAMPAIGN_FORM_FIELDS.SKIP_ON_DAYS}
        allowMultipleSelection
      >
        {SEND_ON_DAYS_OPTIONS.map(({ id, label }) => (
          <GroupButton key={id} id={`${id}`}>
            {label}
          </GroupButton>
        ))}
      </ButtonGroupField>
      {skipOnDaysError?.message && <ErrorText>{skipOnDaysError.message}</ErrorText>}
    </FormField>
  );
};
